import crypto from 'crypto-browserify';

const DADOS_CRIPTOGRAFAR = {
  algoritmo : "aes256",
  codificacao : "utf8",
  tipo : "hex"
}

export const TOKEN_KEY = "@trocasenha-Token";
export const USER_NAME = "@trocasenha-UserName";
export const AUX_CTL = "@trocasenha-AuxCtl";
export const isAuthenticated = () => sessionStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const getUserName = () => sessionStorage.getItem(USER_NAME);
export const getAuxCtl = () => sessionStorage.getItem(AUX_CTL);

export const decryptPass = (encrypted, key) => {
  let decipher = crypto.createDecipher(DADOS_CRIPTOGRAFAR.algoritmo, key, 'binary');
  let decrypted = decipher.update(atob(encrypted), 'binary', 'binary') + decipher.final('binary');
  let plainText = new Buffer(decrypted, 'binary').toString(DADOS_CRIPTOGRAFAR.codificacao);
  return plainText;
}

export const encryptPass = (content, key) => {
  const cipher = crypto.createCipher(DADOS_CRIPTOGRAFAR.algoritmo, key);  
  const crypted = btoa(cipher.update(content, 'binary', 'binary') + cipher.final('binary'));
  return crypted;
}

export const login = (token, userName, auxCtl) => {
  let crypted = encryptPass(auxCtl, userName);
  
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(USER_NAME, userName);
  sessionStorage.setItem(AUX_CTL, crypted);
};


export const logout = () => {
  //console.log('logout');
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_NAME);
  sessionStorage.removeItem(AUX_CTL);
};

